/**
 * API Endpoints for Financial Statements
 * Centralized endpoint definitions following the existing pattern
 */

export const financialStatementsEndpoints = {
  // Base financial statements data
  getFinancialStatement: (companyId: string) => `/companies/${companyId}/reporting/financial-statement`,
  // Investment report data (table format with balance registry)
  getInvestments: (companyId: string) => `/companies/${companyId}/reporting/financial-statement/investments`,
  // Amendment report data (table format with balance registry)
  getAmendments: (companyId: string) => `/companies/${companyId}/reporting/financial-statement/amendments`,
  // Counter amendment report data (table format with balance registry)
  getCounterAmendments: (companyId: string) =>
    `/companies/${companyId}/reporting/financial-statement/amendments/counter-parts`,
  // Financial statement comments
  getComments: (companyId: string) => `/companies/${companyId}/reporting/financial-statement/comments`
} as const
